// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__3vTiT","content":"style_content__23Twl","actions":"style_actions__3EIwc"};